import Modal from "react-responsive-modal";
import "./modal.scss";
import { ReactElement } from "react";

interface IGenericModalProps {
  open: boolean;
  setOpen: (item: boolean) => void;
  title?: string;
  iconTitle?: ReactElement;
  text?: string;
  children?: JSX.Element[] | JSX.Element;
  showActionsButtons?: boolean;
  rightButtonText?: string | JSX.Element;
  leftButtonText?: string | JSX.Element;
  rightButtonStyle?: any;
  leftButtonStyle?: any;
  rightButtonAction?: () => any;
  containerStyle?: any;
  actionsStyle?: any;
}
export default function GenericModal({
  open,
  setOpen,
  children,
  title,
  iconTitle,
  text,
  showActionsButtons = false,
  rightButtonText,
  leftButtonText,
  rightButtonStyle,
  leftButtonStyle,
  rightButtonAction,
  containerStyle,
  actionsStyle
}: IGenericModalProps) {

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        showCloseIcon={false}
        center
      >
        <div className='generic-modal-body' style={containerStyle}>
          {iconTitle && <span className='icon-title'>{iconTitle}</span>}
          {title && <span className='title'>{title}</span>}
          {text && <p className='subtitle'>{text}</p>}

          {children && <div className='generic-children'>
            {children}
          </div>}


          {showActionsButtons && <div className='actions-buttons' style={actionsStyle}>
            <button
              className='cancel'
              onClick={() => setOpen(false)}
              style={leftButtonStyle}
            >
              {leftButtonText}
            </button>
            <button
              className='save'
              style={rightButtonStyle}
              onClick={rightButtonAction}
            >
              {rightButtonText}
            </button>
          </div>}
        </div>
      </Modal>
    </>
  )
}